"use client";

import React from "react";
import { usePathname } from "next/navigation";
import { ENABLE_CHAT } from "@/lib/environmentConfig";
import { MessageCircle } from "lucide-react";
import Button from "../common/Button";
import Image from "next/image";
import "@/styles/contact/sparkles.css";

const ChatTrigger = ({ onClick, isActive, useDesktop = false }) => {
  const pathname = usePathname();
  if (!ENABLE_CHAT) return null;

  if (typeof pathname === "string" && pathname.startsWith("/studio"))
    return null;
  return (
    <Button
      onClick={onClick}
      className="
    fixed 
    bottom-6 right-6 small:bottom-7 small:right-7 sm:bottom-6 sm:right-6 
    z-[9998] 
    rounded-[30px] 
    w-[110px] h-[40px] mobile:w-[110px] mobile:h-[41px] md:w-[134px] md:h-[50px] lg:w-[154px] lg:h-[56px]
    bg-gradient-to-r from-[#F7EFFF] to-[#FFFFFF]
    dark:bg-gradient-to-r dark:from-[#0A0014] dark:to-[#190021]
    border border-[#C500EE] dark:border-[#9E00BF]
    shadow-[0_0_20px_rgba(255,87,249,0.3)]
    hover:shadow-[0_0_35px_rgba(255,87,249,0.5)]
    hover:scale-105
    transition-all duration-300 ease-in-out
  "
      hoverOverlay={false}
      glowOnHover={true}
      glowClassName="!rounded-[30px] shadow-[0_8px_32px_rgba(223,39,223,0.4)]"
    >
      {/* Sparkles  */}
      <span className="pointer-events-none absolute inset-0 rounded-[7px] z-[5]" />

      <span
        aria-hidden
        className="sparkle-star absolute z-[3] left-[10.52px] -top-[7.96px]"
        style={{
          ["--sz"]: "9.48px",
          ["--r"]: "78.26deg",
          animationDelay: "160ms",
        }}
      />
      <span
        aria-hidden
        className="sparkle-star absolute z-[2] left-[119px] -top-[8px] "
        style={{
          ["--sz"]: "12.04px",
          ["--r"]: "-10.95deg",
          animationDelay: "240ms",
        }}
      />
      <span
        aria-hidden
        className="sparkle-star absolute z-[1] left-[132.59px] top-[40.7px] md:left-[135.59px] md:top-[12.7px] lg:left-[3.59px] lg:top-[6.7px] xl:left-[-31.59px] xl:top-[2.7px] 1"
        style={{
          ["--sz"]: "8.94px",
          ["--r"]: "22.46deg",
          animationDelay: "120ms",
        }}
      />
      <span
        aria-hidden
        className="sparkle-star absolute z-0 left-[98px] md:left-[102px] lg:left-[127px] top-[50px] md:top-[53px] lg:top-[43px]"
        style={{
          ["--sz"]: "16px",
          ["--r"]: "-24.87deg",
          animationDelay: "0ms",
        }}
      />
      <span
        aria-hidden
        className="sparkle-star absolute left-[88px] top-[49px] bottom-[10px] 6"
        style={{ ["--sz"]: "8px", ["--r"]: "95deg", animationDelay: "900ms" }}
      />

      <span
        aria-hidden
        className="sparkle-star absolute left-[-18px] top-[42px] bottom-[10px] 6"
        style={{
          ["--sz"]: "18px",
          ["--r"]: "13.52deg",
          animationDelay: "900ms",
        }}
      />
      <span
        aria-hidden
        className="sparkle-star absolute left-[88px] top-[-19px] bottom-[10px] 3"
        style={{ ["--sz"]: "10px", ["--r"]: "95deg", animationDelay: "900ms" }}
      />

      <div className="flex items-center gap-[7px]">
        {/* <div className="w-[30px] h-[30px] flex-shrink-0 mt-1 relative"> */}
        <div
          className="
    relative 
    flex-shrink-0 
    mt-0.5 sm:mt-1 
    w-[24px] h-[24px] 
    sm:w-[24px] sm:h-[24px]
    md:w-[26px] md:h-[26px] 
    lg:w-[30px] lg:h-[30px]
  "
        >
          <Image
            src="/assets/chatBot/ellipse-avatar.svg"
            alt="Bot"
            fill
            className="object-contain"
          />
          <div className="absolute inset-1 rounded-full overflow-hidden">
            <Image
              src="/assets/chatBot/chatBot.webp"
              alt="AI Assistant"
              fill
              className="object-contain"
              sizes="(max-width: 768px) 40px, 48px"
              quality={60}
              priority={false}
              loading="lazy"
            />
          </div>
        </div>
        <span className="font-['Alexandria'] font-bold text-[11px] md:text-[12px] lg:text-[14px] leading-[18px] sm:leading-[20px] bg-gradient-to-r from-[#3D4DD0] to-[#AD08BC] bg-clip-text text-transparent">
          ICIEOS AI
        </span>
      </div>
    </Button>
  );
};

export default ChatTrigger;
